import { Component } from '@theme/component';

/**
 * The article outline.
 *
 * The prototype parses its own article structure and renders the outline from
 * it. Here the body is rich text written in the admin, so the headings are read
 * back out of the rendered HTML and given ids to link to.
 *
 * Only shown from three headings up, which is the prototype's rule: an outline
 * over two sections is furniture, not navigation. Below that the aside stays
 * hidden and the body keeps the full measure.
 *
 * @extends {Component}
 */
class AwhArticle extends Component {
  connectedCallback() {
    super.connectedCallback();

    const body = this.refs.body;
    const aside = this.refs.zij;
    if (!body || !aside) return;

    const headings = [...body.querySelectorAll('h2')].filter((h) => h.textContent.trim());
    if (headings.length < 3) return;

    const items = headings.map((h, i) => {
      // Keep an id the author already set; only invent one when there is none,
      // so existing in-page links keep working.
      if (!h.id) h.id = `kop-${i + 1}-${slug(h.textContent)}`;
      return { id: h.id, text: h.textContent.trim() };
    });

    aside.hidden = false;
    aside.innerHTML = `
      <nav class="art__toc" aria-labelledby="toc-${this.dataset.tocId ?? 'title'}">
        <p class="art__toc-titel" id="toc-${this.dataset.tocId ?? 'title'}">${esc(this.dataset.tocTitle ?? 'In dit artikel')}</p>
        <ol>
          ${items.map((i) => `<li><a href="#${esc(i.id)}">${esc(i.text)}</a></li>`).join('')}
        </ol>
      </nav>`;
  }
}

const slug = (s) =>
  String(s)
    .toLowerCase()
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 40);

const esc = (s) =>
  String(s ?? '').replace(
    /[&<>"']/g,
    (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]
  );

if (!customElements.get('awh-article-component')) {
  customElements.define('awh-article-component', AwhArticle);
}
